module.exports = __webpack_public_path__ + "img/gift_jbl_tt_it.732e1204.jpg";